import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QuillModule } from 'ngx-quill';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ServiceStatusPipe } from './pipes/service-status.pipe';
import { StatusPageRichTextPipe } from './pipes/status-page-rich-text.pipe';

// Material Modules
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDividerModule } from '@angular/material/divider';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatTreeModule } from '@angular/material/tree';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// Dialogs
import { DeleteConfirmDialogComponent } from './dialogs/delete-dialog/delete-confirm-dialog.component';
import { ServiceDialogComponent } from './dialogs/service-dialog/service-dialog.component';
import { GroupDialogComponent } from './dialogs/service-group-dialog/group-dialog.component';
import { StatusPageManageMaintenanceDialogComponent } from './dialogs/manage-maintenance-dialog/manage-maintenance-dialog.component';
import { StatusPageManageIncidentDialogComponent } from './dialogs/manage-incident-dialog/manage-incident-dialog.component';
import { TemplateDialogComponent } from './dialogs/template-dialog/template-dialog.component';
import { AddServicesToGroupDialogComponent } from './dialogs/add-services-to-group-dialog/add-services-to-group-dialog.component';
import { SideDrawerComponent } from './components/side-drawer/side-drawer.component';

// Components
import { CustomSelectComponent } from './components/custom-select/custom-select.component';
import { StatsCardComponent } from './components/stats-card/stats-card.component';
import { ServiceTreeComponent } from './components/service-tree/service-tree.component';
import { DateTimePickerComponent } from './components/date-time-picker/date-time-picker.component';
import { ServiceAccessControlComponent } from './components/service-access-control/service-access-control.component';
import { IncidentPostmortemComponent } from './components/incident-postmortem/incident-postmortem.component';


const STANDALONE_DECLARABLES = [
    DeleteConfirmDialogComponent,
    ServiceDialogComponent,
    GroupDialogComponent,
    StatusPageManageMaintenanceDialogComponent,
    TemplateDialogComponent,
    AddServicesToGroupDialogComponent,
    SideDrawerComponent,
    CustomSelectComponent,
    StatsCardComponent,
    ServiceTreeComponent,
    DateTimePickerComponent,
    ServiceAccessControlComponent,
    ServiceStatusPipe,
    StatusPageRichTextPipe,
    StatusPageManageIncidentDialogComponent,
    IncidentPostmortemComponent
];

const MATERIAL_MODULES = [
    MatButtonModule,
    MatIconModule,
    MatExpansionModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatChipsModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatDividerModule,
    MatTabsModule,
    MatCardModule,
    MatListModule,
    MatTreeModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgxSkeletonLoaderModule,
        NgbModule,
        ...STANDALONE_DECLARABLES,
        ...MATERIAL_MODULES,
        QuillModule
    ],
    exports: [
        ...STANDALONE_DECLARABLES,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgxSkeletonLoaderModule,
        NgbModule,
        QuillModule,
        ...MATERIAL_MODULES
    ],

})
export class StatusPageSharedModule { }








